// Components==============
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Checkbox.module.scss';
// =========================

export default function Checkbox({
  isChecked,
  setIsChecked,
  onClick,
  children,
  disabled,
  type,
}: {
  isChecked: boolean;
  setIsChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  type?: 'green';
}) {
  return (
    <div
      styleName="wrapper"
      onClick={() =>
        onClick && !disabled
          ? onClick()
          : setIsChecked && !disabled
          ? setIsChecked((prev) => !prev)
          : disabled
          ? null
          : undefined
      }
    >
      <div
        styleName={`checkbox ${
          isChecked && type === undefined
            ? 'checked'
            : isChecked && type === 'green'
            ? 'green'
            : ''
        }`}
      >
        <FontAwesomeIcon icon={faCheck} />
      </div>
      <div styleName="text">{children}</div>
    </div>
  );
}
